<template>
    <b-modal
        id="homepage-video"
        ref="homepageVideo"
        centered
        @hide="onHide"
        size="xl"
        hide-header
        hide-footer>
        <div class="homepage-video">
            <button
                @click="$bvModal.hide(`homepage-video`)"
                aria-label="Close"
                id="modal-close"
                class="close-modal pr-2">
                    <Icon icon="close-modal" />
            </button>
            <div class="video-modal mx-auto d-flex justify-content-center align-items-center position-relative">
                <iframe
                    src="https://www.youtube.com/embed/-dvNHxoBygI?autoplay=1"
                    frameborder="0"
                    allow="autoplay; fullscreen"
                    allowfullscreen>></iframe>
            </div>
        </div>
    </b-modal>
</template>

<script>
import Icon from '../components/Theme/Icon'
export default {
    name: 'HomepageVideo',
    components: {
        Icon,
    },
    methods: {
        onHide: function(evt) {
            this.$bvModal.hide('homepage-video')
        },
    }
}
</script>

<style lang="scss" scoped>
.homepage-video {
    position: relative;

    button.close-modal {
        position: absolute;
        right: -48px;
        top: 0;
        z-index: 2000;
    }
}
div.video-modal {
    width: 100%;
    height: calc(100vh - 60px);

    iframe {
        width: 100%;
        height: 100%;
    }
}
</style>